
            const data = {"name":"minus","data":{"viewBox":"0 0 60 60","data":"<path pid=\"0\" _fill=\"#171614\" d=\"M1 22.75h58v14.5H1z\"/>","originalColors":[{"type":"fill","color":"#171614"}],"stopColors":[]}}
        
                module.exports = data
                